<script lang="ts">
import {defineComponent} from 'vue'
import FloatLabel from 'primevue/floatlabel'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Select from 'primevue/select'
import LoginContainer from "@/components/Global/Layout/LoginContainer.vue";
import backendRoutes from "@/backendRoutes";
import {fetchWrapper} from "@/helpers/fetchWrapper";

export default defineComponent({
  name: 'ResetPasswordView',
  components: {
    LoginContainer,
    FloatLabel,
    InputText,
    Button,
    Select
  },
  data() {
    return {
      entityTypeOptions: ["student",/* "teacher",*/ "contact_person"] as string[],
      email: '' as string,
      isLoading: false as boolean,
      entityType: 'student',
      isReset: false as boolean,
      token: this.$route.query.token ? this.$route.query.token : null as string | null,
      type: this.$route.query.type ? this.$route.query.type : null as string | null,
      tokenCheck: false as boolean,
      isUpdated: false as boolean,
      password: '' as string,
      passwordRepeat: '' as string
    }
  },
  mounted() {
    if(this.token != null) this.checkToken()
  },
  computed: {
    isCreate() {
      return this.$route.params.create == '1'
    }
  },
  methods: {
    async checkToken(){
      this.isLoading = true
      if(this.token == null) return
      if(this.type == null) return

      let route = ''
      switch (this.type) {
        case "student":
          route = backendRoutes.student_check_password_reset_token.replace('{passwordResetToken}', String(this.token))
          break
        case "teacher":
          route = backendRoutes.teacher_check_password_reset_token.replace('{passwordResetToken}', String(this.token))
          break
        case "contact_person":
          route = backendRoutes.contact_person_check_password_reset_token.replace('{passwordResetToken}', String(this.token))
          break
      }

      await fetchWrapper.post(route).then(() => {
        this.tokenCheck = true
      }).catch((error: any) => {
        if(error == "not_found") error = this.$t('password_reset_view.messages.errors.token_not_found')
        else if(error == "token_expired") error = this.$t('password_reset_view.messages.errors.token_expired')
        this.$toast.add({severity:'error', summary: this.$t('password_reset_view.messages.error_title'), detail: error, life: 5000})
      })

      this.isLoading = false
    },
    async submitUpdatePassword(e: SubmitEvent) {
      if(this.password != this.passwordRepeat) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('password_reset_view.messages.error_title'),
          detail: this.$t('password_reset_view.messages.errors.password_different'),
          life: 5000
        })
      }else {
        this.isLoading = true
        let route = ''
        switch (this.type) {
          case "student":
            route = backendRoutes.student_update_password.replace('{passwordResetToken}', String(this.token))
            break
          case "teacher":
            route = backendRoutes.teacher_update_password.replace('{passwordResetToken}', String(this.token))
            break
          case "contact_person":
            route = backendRoutes.contact_person_update_password.replace('{passwordResetToken}', String(this.token))
            break
        }

        await fetchWrapper.post(route,{password: this.password}).then(() => {
          this.isUpdated = true
        }).catch((error: any) => {
          if (error == "not_found") error = this.$t('password_reset_view.messages.errors.not_found')
          else if (error == "email_error") error = this.$t('password_reset_view.messages.errors.email_error')
          this.$toast.add({
            severity: 'error',
            summary: this.$t('password_reset_view.messages.error_title'),
            detail: error,
            life: 5000
          })
        })
      }
      this.isLoading = false
      e.preventDefault()
      e.stopPropagation()
    },
    async submitAskReset(e: SubmitEvent){
      this.isLoading = true
      let route = ''
      if(this.entityType == undefined) return
      switch (this.entityType) {
        case "student":
          route = backendRoutes.student_password_reset.replace('{email}', String(this.email))
          break
        case "teacher":
          route = backendRoutes.teacher_password_reset.replace('{email}', String(this.email))
          break
        case "contact_person":
          route = backendRoutes.contact_person_password_reset.replace('{email}', String(this.email))
          break
      }

      await fetchWrapper.post(route, undefined, {isCreate: this.isCreate }).then(() => {
        this.isReset = true
      }).catch((error: any) => {
        if(error == "not_found") error = this.$t('password_reset_view.messages.errors.not_found')
        else if(error == "email_error") error = this.$t('password_reset_view.messages.errors.email_error')
        this.$toast.add({severity:'error', summary: this.$t('password_reset_view.messages.error_title'), detail: error, life: 5000})
      })

      this.isLoading = false
      e.preventDefault()
      e.stopPropagation()
    },
    getEntityTypeLabel(value: string){
      return this.$t("password_reset_view.messages.entity_type_label."+value)
    },
  }
});
</script>

<template>
  <LoginContainer :isLoading="isLoading">
    <div v-if="token == null">
      <div v-if="isReset">
        <p style="margin-bottom: 1rem;">{{ isCreate ? $t('password_reset_view.view.config_text') : $t('password_reset_view.view.reset_text') }}</p>
        <RouterLink :to="{name: 'login'}">
          <Button :label="$t('password_reset_view.view.login_button')" fluid />
        </RouterLink>
      </div>
      <form v-else @submit="submitAskReset">
        <p>{{ isCreate ? $t('password_reset_view.view.information_text_create') : $t('password_reset_view.view.information_text') }}</p>
        <FloatLabel>
          <InputText id="email" v-model="email" fluid type="email" required />
          <label for="email">{{ $t('password_reset_view.view.email_label') }}</label>
        </FloatLabel>
        <FloatLabel>
          <Select id="entity_type" :options="entityTypeOptions" :optionLabel="getEntityTypeLabel"
                  v-model="entityType" fluid />
          <label for="entity_type">{{ $t('password_reset_view.view.entity_type_label') }}</label>
        </FloatLabel>
        <Button :label="$route.params.create == '1' ? $t('password_reset_view.view.create_button') : $t('password_reset_view.view.reset_button')" fluid type="submit" />
        <RouterLink :to="{name: 'login'}">
          <Button :label="$t('password_reset_view.view.cancel_button')" fluid severity="secondary" style="margin-top: 1rem;" />
        </RouterLink>
      </form>
    </div>
    <div v-else>
      <div v-if="tokenCheck">
        <div v-if="isUpdated">
          <p>{{ $t('password_reset_view.view.password_updated_text')}}</p>
          <RouterLink :to="{name: 'login'}">
            <Button :label="$t('password_reset_view.view.login_button')" fluid />
          </RouterLink>
        </div>
        <div v-else>
          <p>{{ $t('password_reset_view.view.password_reset_text')}}</p>
          <form @submit="submitUpdatePassword">
            <FloatLabel>
              <InputText id="password" fluid type="password" required v-model="password" />
              <label for="password">{{ $t('password_reset_view.view.password_label') }}</label>
            </FloatLabel>
            <FloatLabel>
              <InputText id="password_repeat" fluid type="password" required v-model="passwordRepeat" :invalid="this.password != this.passwordRepeat" />
              <label for="password_repeat">{{ $t('password_reset_view.view.password_repeat_label') }}</label>
            </FloatLabel>
            <Button :label="$route.params.create == '1' ? $t('password_reset_view.view.create_button') : $t('password_reset_view.view.reset_button')" fluid type="submit" />
          </form>
        </div>
      </div>
      <p v-else>{{ $t('password_reset_view.messages.errors.token_expired') }}</p>
    </div>
  </LoginContainer>
</template>

<style scoped lang="scss">
p{
  font-size: 0.9rem;
  margin-bottom: 1.7rem;
}
:deep(.p-floatlabel){
  margin-bottom: 1.7rem;
}

:deep(.p-select){
  margin-bottom: 1rem;
}
</style>
